import { render, staticRenderFns } from "./AddNewUpdate.vue?vue&type=template&id=0b43cb6a"
import script from "./AddNewUpdate.vue?vue&type=script&lang=js"
export * from "./AddNewUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddNewUpdate.vue?vue&type=style&index=0&id=0b43cb6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports